<div class="container-fluid text-md-left background-success footer-fix pos-abs bottom-0 ">
    <div class="text-white py-3 footer-font-size text-center">
        All right Reserved @ Herbtech 2021
    </div>
</div>
